import { render, staticRenderFns } from "./HeaderError.vue?vue&type=template&id=8b525634&scoped=true&"
import script from "./HeaderError.vue?vue&type=script&lang=js&"
export * from "./HeaderError.vue?vue&type=script&lang=js&"
import style1 from "./HeaderError.vue?vue&type=style&index=1&id=8b525634&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b525634",
  null
  
)

export default component.exports